export const GET_ALL_OUTGOING_TARGETS = 'GET:ALL:OUTGOING:TARGETS';
export const GET_OUTGOING_TARGETS_WITH_PAGINATION = 'GET:ALL:OUTGOING:TARGETS';
